<template>
  <vx-card v-show="isCardActiveLocal" class="mt-3 mb-4" title="Final Summary">
    <div class="vx-row">
      <div class="flex flex-wrap items-center justify-center">
        <p class="ml-4 mr-2">Final Score: </p>
        <vs-input type="number" autocomplete="off" style="width: 58px;" class="mr-2" min="0" :max="captureTask.totalMarks" size="small" name="score" v-model="captureTask.achievedMarks" />
        <p class="mr-2">/</p>
        <vs-input type="number" autocomplete="off" style="width: 58px;" class="mr-2" min="0" size="small" name="total" v-model="captureTask.totalMarks" />
      </div>
    </div>
    <div v-if="captureTask.studentComment" class="mt-2 vx-row">
      <div class="vx-col flex-1">
        <label>Student Comment:</label>
        <vs-textarea id="studentComment" readOnly v-model="captureTask.studentComment" />
      </div>
    </div>
    <div class="mt-2 vx-row">
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <label>Comment:</label>
        <vs-textarea v-model="captureTask.assessorComment" />
      </div>
      <div class="vx-col xs:w-full sm:w-full md:w-full lg:w-1/2 xl:w-1/2">
        <label>Predefined Comments:</label>
        <v-select placeholder="Search / Select Predefined Comment" :options="predefinedComments" v-model="predCommentDropdown" @search:blur="addComment"></v-select>
      </div>
    </div>
  </vx-card>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      captureTask: {
        type: Object,
        required: false
      },
      predefinedComments: {
        type: Array,
        required: false
      }
    },
    data() {
      return {
        predCommentDropdown: 0
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          
        }
      }
    },
    methods: {
      addComment() {
        var self = this;
        if(self.predCommentDropdown){
          if(self.captureTask.assessorComment == null) {
            self.captureTask.assessorComment = "";
          }
          self.captureTask.assessorComment += self.predCommentDropdown.label + " ";
        }
      }
    },
    mounted() {
      
    },
  }

</script>

<style lang="scss">
  #studentComment {
    box-shadow: 0 4px 20px 0 rgba(var(--vs-danger),0.3);
  }
</style>
